"use client";

import { FC, useEffect, useState } from "react";

export const useDotEllipsisAnimation = (speed = 500): string => {
  const [ellipsis, setEllipsis] = useState<string>(".");

  useEffect(() => {
    const intervalId = setInterval(() => {
      setEllipsis((prevEllipsis) =>
        prevEllipsis === "..." ? "" : prevEllipsis + "."
      );
    }, speed);

    return () => clearInterval(intervalId);
  }, [speed]);

  return ellipsis;
};

type TextEllipsisProgressProps = {
  speed: number;
};

const TextEllipsisProgress: FC<TextEllipsisProgressProps> = (
  props: TextEllipsisProgressProps
) => {
  const ellipsis = useDotEllipsisAnimation(props.speed);
  return (
    <span className="w-2 text-start inline-block overflow-visible">
      <span className="overflow-visible">{ellipsis}</span>
    </span>
  );
};

TextEllipsisProgress.displayName = "TextEllipsisProgress";

export default TextEllipsisProgress;
